import { graphql } from "@/lib/gql/__generated__";

export const RoomPriceRankGetNewPriceRankItem_RoomPriceRankPage_Query = graphql(`
	query RoomPriceRankGetNewPriceRankItem($hotelID: ID!) {
		roomPriceRankGetNewPriceRankItem(hotelID: $hotelID) {
			priceRankID
			name
			color
			rooms {
				roomID
				roomName
				prices {
					adultNum
					price {
						currencyType
						amount
					}
				}
			}
			isStopSelling
		}
	}
`);
